// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SmallCard_cardContainer__1myUw","bottom":"SmallCard_bottom__1qxbp"};